<div class="slider-area ">
  <!-- Mobile Menu -->
  <div class="tf-page-title">
    <div class="container-full">
        <div class="heading text-center"> CONTACTEZ-NOUS</div>

    </div>
</div>
</div>
<div class="container contact-page">
  <div class="row">
    <!-- Section Informations -->
    <div class="col-md-6">
      <div class="info-section">
        <h3 class="section-title">INFORMATIONS</h3>
        <div class="info-item">
          <i class="fas fa-shopping-cart icon"></i>
          <span>
          A'DORA :
Notre dévouement se traduit par la création de produits uniques qui utilisent les matériaux les plus fins et un design distinctif pour exprimer votre individualité.
Nous sommes confiants que vous trouverez le choix parfaitement adapté à vos besoins et à votre style.
          </span>
        </div>
        <div class="info-item">
          <i class="fas fa-phone-alt icon"  style="transform: scaleX(-1);"></i>
          <span>Appelez-nous : <strong  style="cursor: pointer;">+216 58955712</strong></span>
        </div>
        <div class="info-item">
          <i class="fas fa-envelope icon"></i>
          <span>
            Envoyez-nous un e-mail :
            <a href="mailto:adorastoretn@gmail.com">adorastoretn@gmail.com</a>
          </span>
        </div>
        <div class="info-item">
          <i class="fab fa-facebook-f icon"></i>
          <a href="https://www.facebook.com/Adora.Store2" target="_blank">
            Facebook:ecommus
          </a>
        </div>
        <div class="info-item">
          <i class="fab fa-instagram icon"></i>
          <a href="https://www.instagram.com/adora_store_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank">
            ecommus.site
          </a>
        </div>
      </div>
    </div>

    <!-- Section Contactez-nous -->
    <div class="col-md-6">
      <div class="contact-form">
        <h3 class="section-title">CONTACTEZ-NOUS</h3>
        <form (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="subject">Sujet</label>
            <select id="subject" name="subject" required>
              <option value="Service client">Service client</option>
              <option value="Support technique">Support technique</option>
              <option value="Retour produit">Retour produit</option>
              <option value="Autre">Autre</option>
            </select>
          </div>
          <div class="form-group">
            <label for="email">Adresse e-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              required
            />
          </div>
          <div class="form-group">
            <label for="file">Document joint</label>
            <input
              type="file"
              id="file"
              (change)="onFileChange($event)"
            />
            <small class="text-muted">Optionnel</small>
          </div>
          <div class="form-group">
            <label for="message">Message</label>
            <textarea
              id="message"
              rows="5"
              name="message"
              required
            ></textarea>
          </div>
          <button type="submit"  class="tf-btn btn-fill fw-4 animate-hover-btn rounded-0 letter-2" style="cursor: pointer;">Envoyer</button>
        </form>
      </div>
    </div>
  </div>
</div>

